import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/Header2/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-374416ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-index"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "nav"
};
const _hoisted_7 = {
  class: "links"
};
const _hoisted_8 = {
  href: "https://t.me/memeisagame",
  target: "_blank"
};
const _hoisted_9 = {
  href: "https://x.com/memeisgame",
  target: "_blank"
};
const _hoisted_10 = {
  class: "wallet"
};
const _hoisted_11 = {
  key: 0,
  class: "main2"
};
import { ref, getCurrentInstance, computed, watch, onMounted } from "vue";
// 钱包适配器
import { useWallet } from "solana-wallets-vue";
import { formatAddress, getCookie } from "@/utils";
import WalletConnectList from "@/components/WalletConnectList";
import HeaderNotify from "../HeaderNotify";
import FooterMenu from "@/components/FooterMenu";
import { useRoute } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const {
      $route,
      $store,
      $router,
      $Toast
    } = getCurrentInstance().proxy;
    const walletConnectListRefs = ref(null);
    const {
      publicKey,
      wallets,
      wallet,
      connected,
      connecting,
      disconnect
    } = useWallet();
    const publicKeyAddressStore = computed(() => $store.state.publicKeyAddress);
    const loginSignStore = computed(() => $store.state.loginSign);
    const route = useRoute();
    const id = route.params.id;
    onMounted(() => {
      watch(publicKey, newPublicKey => {
        if (newPublicKey) {
          const publicKeyBase58 = newPublicKey?.toBase58();
          $store.commit("updatePublicKeyAddress", publicKeyBase58);
        } else {
          $store.commit("updatePublicKeyAddress", "");
        }
      }, {
        immediate: true
      } // 初次加载时立即执行
      );
    });
    async function walletConnect() {
      walletConnectListRefs.value.getFlag({
        type: true
      });
    }
    async function viewProfile() {
      try {
        // 链接钱包、存有loginSign、并且cookie存有token和secret才可以进入自己页面
        const login_token = getCookie("login_token");
        const login_secret = getCookie("login_secret");
        if (wallet.value && connected.value && loginSignStore.value && login_token && login_secret) {
          $router.push({
            name: "tokensHoldWithId",
            params: {
              id: publicKeyAddressStore.value
            }
          });
        } else {
          $Toast({
            message: "Wallet connection error, please reconnect the wallet!",
            status: "fail",
            duration: 3000
          });
          await disconnect();
          $store.commit("updateLoginSign", "");
          $store.commit("updateLastSignedAddress", "");
        }
      } catch (error) {
        $Toast({
          message: "Wallet connection error, please reconnect the wallet!",
          status: "warning",
          duration: 3000
        });
        await disconnect();
        $store.commit("updateLoginSign", "");
        $store.commit("updateLastSignedAddress", "");
      }
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_van_sticky = _resolveComponent("van-sticky");
      return _openBlock(), _createBlock(_component_van_sticky, {
        width: "100%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
          to: {
            name: 'memeboard'
          },
          custom: ""
        }, {
          default: _withCtx(({
            navigate
          }) => [_createElementVNode("div", {
            class: "logo",
            onClick: navigate
          }, _hoisted_5, 8, _hoisted_3)]),
          _: 1
        }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("a", _hoisted_8, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-tg",
          class: "icon"
        })]), _createElementVNode("a", _hoisted_9, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-x",
          class: "icon"
        })])]), _createElementVNode("div", _hoisted_10, [publicKeyAddressStore.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "full address",
          onClick: viewProfile
        }, _toDisplayString(_unref(formatAddress)(publicKeyAddressStore.value, 4, 2)), 1)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: walletConnect,
          class: "full wallet-connect"
        }, _toDisplayString(_unref(connecting) ? "Connecting..." : "CONNECT"), 1))])])]), _unref($route).path != '/' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_unref(HeaderNotify))])) : _createCommentVNode("", true), _createVNode(_unref(WalletConnectList), {
          ref_key: "walletConnectListRefs",
          ref: walletConnectListRefs,
          walletList: _unref(wallets)
        }, null, 8, ["walletList"])]), _unref(id) && (_unref($route).name == 'boardDetail' || _unref($route).name == 'charts' || _unref($route).name == 'trade' || _unref($route).name == 'txs') ? (_openBlock(), _createBlock(_unref(FooterMenu), {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};